const styles = () => ({
  fieldHolder: {
    '&:before': {
      display: 'none',
    },
    '&:after': {
      display: 'none',
    },
    width: '100%',
    border: '1px solid #d9d9d9',
    borderRadius: 50,
    padding: '0 10px',
    boxSizing: 'border-box',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/SearchBar/styles.js